import styled from 'styled-components';
import {
  borderRadius,
  breakpoints,
  colors,
  verticalGutter
} from '../../styles';
import { Grid } from 'semantic-ui-react';

export const StyledGrid = styled(Grid)`
  &,
  &.ui.grid {
    border-radius: ${borderRadius.medium};
    display: flex;
    flex-direction: column;
    align-items: center !important;
    justify-content: center;
    flex: 1;
    text-align: center;
    padding: ${verticalGutter * 2}rem 0;
    margin: 0;
    margin-left: 0 !important;
    margin-right: 0 !important;
    height: 100%;
    border: 1px solid ${colors.lighterGrey};
    .ui.grid + & {
      margin-top: ${verticalGutter * 0.75}rem;
    }

    img {
      margin: 0.5rem;
      display: inline-block;
    }

    /* namespace'd styles */
    .searchresultsplaceholder {
      &__images {
        padding: 0;
        margin: 0;
        list-style: none;
        display: flex;
        justify-content: center;
      }

      &__content {
        @media screen and (min-width: ${breakpoints.tablet}) {
          padding-left: ${verticalGutter / 2}rem;
          padding-right: ${verticalGutter / 2}rem;

          .message {
            margin-left: ${verticalGutter / -2}rem;
            margin-right: ${verticalGutter / -2}rem;
            width: calc(100% + ${verticalGutter}rem);
          }
        }
      }
    }
  }
`;
